import React, { FC } from 'react'
import moment from 'moment'
import { Button, Space } from 'antd'

interface DateFilterProps {
    onChangeDate: (e: any) => void
    onDateActive: any
}

const DateFilter: FC<DateFilterProps> = ({ onChangeDate, onDateActive }) => {
    const sDateActive = moment(onDateActive?.start).format('YYYY-MM-DD');
    const eDateActive = moment(onDateActive?.end).format('YYYY-MM-DD');

    let activeClass: string = "";
    switch (`${sDateActive}-${eDateActive}`) {
        case `${moment().format('YYYY-MM-DD')}-${moment().format('YYYY-MM-DD')}`:
            activeClass = "today"
            break;

        case `${moment().subtract(1, 'days').format('YYYY-MM-DD')}-${moment().subtract(1, 'days').format('YYYY-MM-DD')}`:
            activeClass = "yesterday"
            break;

        case `${moment().startOf('isoWeek').format('YYYY-MM-DD')}-${moment().endOf('isoWeek').format('YYYY-MM-DD')}`:
            activeClass = "this_week"
            break;

        case `${moment().startOf('isoWeek').subtract(7, 'days').format('YYYY-MM-DD')}-${moment().endOf('isoWeek').subtract(7, 'days').format('YYYY-MM-DD')}`:
            activeClass = "last_week"
            break;

        case `${moment().startOf('month').format('YYYY-MM-DD')}-${moment().endOf('month').format('YYYY-MM-DD')}`:
            activeClass = "this_month"
            break;

        case `${moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')}-${moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')}`:
            activeClass = "last_month"
            break;

        default:
            break;
    }

    const onDateSearch = (date: any) => {
        if (date !== null) {
            onChangeDate && onChangeDate({
                start: moment(date[0]).format('YYYY-MM-DD'),
                end: moment(date[1]).format('YYYY-MM-DD'),
            })
        }
    }

    return (
        <Space size={4} className="date-filter">
            <Button type={activeClass === 'today' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().startOf('day'), moment().endOf('day')])}>Today</Button>
            <Button type={activeClass === 'yesterday' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')])}>Yesterday</Button>
            <Button type={activeClass === 'this_week' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().startOf('isoWeek'), moment().endOf('isoWeek')])}>This week</Button>
            <Button type={activeClass === 'last_week' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().startOf('isoWeek').subtract(7, 'days'), moment().endOf('isoWeek').subtract(7, 'days')])}>Last week</Button>
            <Button type={activeClass === 'this_month' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().startOf('month'), moment().endOf('month')])}>This month</Button>
            <Button type={activeClass === 'last_month' ? 'primary' : 'text'} onClick={() => onDateSearch([moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')])}>Last month</Button>
        </Space>
    )
}

export default DateFilter